import type { Currency } from '@/scopes/common/domain/types';

export const currencyResolver = (function IIFE() {
  const localeToDefaultCurrencyMap: Record<string, Currency> = {
    'da-DK': 'DKK',
    'en-GB': 'GBP',
    'sv-SE': 'SEK',
  };

  const resolveDefaultForLocale = (locale?: string) => localeToDefaultCurrencyMap?.[locale ?? ''] ?? 'EUR';

  return { resolveDefaultForLocale };
})();
